<div class="navbar">
    <nav style="width: 100%;top: 0px;position: relative;">
        <mat-nav-list style="width: 13%; float: right" class="inline" fxLayout="row">
            <!-- USER INFORMATION -->
            <a mat-list-item class="user-details-header" style="height: 34px;">
                <div class="usermenu" [matMenuTriggerFor]="beforeMenu">
                    <div *ngIf="profileInitials != ''" class="circle">{{profileInitials}}</div>
                    <div>
                        <div class="user-sub-text">{{userName}} </div>
                        <div class="user-sub-text-site">{{site}} </div>
                    </div>
                    <mat-icon class="user-arrow-down">expand_more</mat-icon>
                </div>

                <mat-menu class="usermenu" #beforeMenu="matMenu">
                    <button class="user-items-text" mat-menu-item (click)="logout()">
                        <mat-icon>{{navlinks.user.logout.icon}} </mat-icon>
                        {{navlinks.user.logout.displayName}}
                    </button>
                </mat-menu>
            </a>
        </mat-nav-list>

        <mat-tab-group *ngIf="validationComplete" (selectedIndexChange)="onTabClick($event)"
            class="remove-border-bottom" style="width: 66%; float: right;" color="warn" animationDuration="0ms"
            [ngClass]="arrowHidden? 'arrow-hidden' : '' " [selectedIndex]="selected.value">
            <mat-tab style="width: 4%;" *ngIf="validatedMenuItem.home">
                <ng-template mat-tab-label>
                    <a class="home" class="navbar-brand pl-3 pr-3"
                        [ngClass]="highlightHome? 'homeactive' : 'homeinactive' "
                        (click)="naviagte('/home'); toggler('home')">
                        <mat-icon class="user-arrow-down homeGrey" style="font-size: 22px;">home</mat-icon>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.documentControl">
                <ng-template mat-tab-label mat-mdc-tab-label>
                    <a mat-list-item class="p15" style="height: 100%;"
                        (click)="naviagte(navlinks.documentControl.url); toggler('document-control');">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">
                                    {{navlinks.documentControl.displayName}}</div>
                            </div>
                        </div>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.unload">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" (click)="naviagte(navlinks.unload.url); toggler('unload')">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">{{navlinks.unload.displayName}}</div>
                            </div>
                        </div>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.reload">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" (click)="naviagte(navlinks.reload.url); toggler('reload')">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">{{navlinks.reload.displayName}}</div>
                            </div>
                        </div>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.boxLevel">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" [matMenuTriggerFor]="boxLevelMenu">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">Box Level</div>
                            </div>
                            <mat-icon class="menu-arrow-down">expand_more</mat-icon>
                        </div>

                        <mat-menu class="usermenu" #boxLevelMenu="matMenu">
                            <button *ngIf="validatedMenuItem.boxLevelSubdocumentControl" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.boxLevel.documentControl.url"
                                (click)="toggler('box-level')">{{navlinks.boxLevel.documentControl.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item [routerLink]="navlinks.boxLevel.unload.url"
                                (click)="toggler('box-level')">{{navlinks.boxLevel.unload.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item [routerLink]="navlinks.boxLevel.reload.url"
                                (click)="toggler('box-level')">{{navlinks.boxLevel.reload.displayName}}</button>
                        </mat-menu>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.returnables">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" [matMenuTriggerFor]="returnablesMenu">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">Returnables</div>
                            </div>
                            <mat-icon class="menu-arrow-down">expand_more</mat-icon>
                        </div>

                        <mat-menu class="usermenu" #returnablesMenu="matMenu">
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.returnables.returnsunload.url"
                                (click)="toggler('returnables')">{{navlinks.returnables.returnsunload.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.returnables.returnsreload.url"
                                (click)="toggler('returnables')">{{navlinks.returnables.returnsreload.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.returnables.returnRouteSummary.url"
                                (click)="toggler('returnables')">{{navlinks.returnables.returnRouteSummary.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.returnables.returnsPCB.url"
                                (click)="toggler('reports')">{{navlinks.returnables.returnsPCB.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.returnables.returnsHistory.url"
                                (click)="toggler('returnables')">{{navlinks.returnables.returnsHistory.displayName}}</button>


                        </mat-menu>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.reports">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" [matMenuTriggerFor]="reportsMenu">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">Reports</div>
                            </div>
                            <mat-icon class="menu-arrow-down">expand_more</mat-icon>
                        </div>

                        <mat-menu class="usermenu" #reportsMenu="matMenu">
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.routeSummary.url"
                                (click)="toggler('reports')">{{navlinks.reports.routeSummary.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item [routerLink]="navlinks.reports.routePCB.url"
                                (click)="toggler('reports')">{{navlinks.reports.routePCB.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.orderSummary.url"
                                (click)="toggler('reports')">{{navlinks.reports.orderSummary.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item [routerLink]="navlinks.reports.pdfReports.url"
                                (click)="toggler('reports')">{{navlinks.reports.pdfReports.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.laneInquiry.url"
                                (click)="toggler('reports')">{{navlinks.reports.laneInquiry.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.TSCSDataSummary.url"
                                (click)="toggler('reports')">{{navlinks.reports.TSCSDataSummary.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.fvmdatadownload.url"
                                (click)="toggler('reports')">{{navlinks.reports.fvmdatadownload.displayName}}</button>
                            <button *ngIf="validatedMenuItem.reportsSublaneSummary" class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.laneSummary.url"
                                (click)="toggler('reports')">{{navlinks.reports.laneSummary.displayName}}</button>
                            <button *ngIf="validatedMenuItem.reportsSublaneDataDownload" class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.reports.laneDataDownload.url"
                                (click)="toggler('reports')">{{navlinks.reports.laneDataDownload.displayName}}</button>

                        </mat-menu> 
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.administration">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" [matMenuTriggerFor]="administrationMenu">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">Administration</div>
                            </div>
                            <mat-icon class="menu-arrow-down">expand_more</mat-icon>
                        </div>

                        <mat-menu class="usermenu" #administrationMenu="matMenu">
                            <button *ngIf="validatedMenuItem.administrationSubsiteConfiguration" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.siteConfiguration.url"
                                (click)="toggler('administration')">{{navlinks.administration.siteConfiguration.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubuserManagement" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.userManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.userManagement.displayName}}</button>
                            <!-- <button *ngIf="validatedMenuItem.administrationSubcLoadManagement" class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.administration.cLoadManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.cLoadManagement.displayName}}</button> -->
                            <button *ngIf="validatedMenuItem.administrationSubconnectionManagement"
                                class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.administration.connectionManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.connectionManagement.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubworkDayManagement" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.workDayManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.workDayManagement.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubdockManagement" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.dockManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.dockManagement.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubshopManagement" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.shopManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.shopManagement.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubcomplianceManagement"
                                class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.administration.complianceManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.complianceManagement.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubcomplianceReview" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.complianceReview.url"
                                (click)="toggler('administration')">{{navlinks.administration.complianceReview.displayName}}</button>
                            <!-- <button *ngIf="validatedMenuItem.administrationSubdockDoorManagement" class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.administration.dockDoorManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.dockDoorManagement.displayName}}</button> -->
                            <button *ngIf="validatedMenuItem.administrationSubsystemManagement" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.systemManagement.url"
                                (click)="toggler('administration')">{{navlinks.administration.systemManagement.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubpcbConfig" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.ppcbconfig.url"
                                (click)="toggler('administration')">{{navlinks.administration.ppcbconfig.displayName}}</button>
                            <button *ngIf="validatedMenuItem.administrationSubpcbConfig" class="menu-items-text"
                                mat-menu-item [routerLink]="navlinks.administration.rpcbconfig.url"
                                (click)="toggler('administration')">{{navlinks.administration.rpcbconfig.displayName}}</button>
                        </mat-menu>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.exportParts">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" [matMenuTriggerFor]="exportPartsMenu">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text">Export Parts</div>
                            </div>
                            <mat-icon class="menu-arrow-down">expand_more</mat-icon>
                        </div>

                        <mat-menu class="usermenu" #exportPartsMenu="matMenu">
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.exportParts.containerConsolidation.url"
                                (click)="toggler('export-parts')">{{navlinks.exportParts.containerConsolidation.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.exportParts.pdfGenerationModuleId.url"
                                (click)="toggler('export-parts')">{{navlinks.exportParts.pdfGenerationModuleId.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.exportParts.pdfGenerationContainerId.url"
                                (click)="toggler('export-parts')">{{navlinks.exportParts.pdfGenerationContainerId.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.exportParts.uploadDocInfo.url"
                                (click)="toggler('export-parts')">{{navlinks.exportParts.uploadDocInfo.displayName}}</button>
                            <button class="menu-items-text" mat-menu-item
                                [routerLink]="navlinks.exportParts.exportLoadType.url"
                                (click)="toggler('export-parts')">{{navlinks.exportParts.exportLoadType.displayName}}</button>

                        </mat-menu>
                    </a>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="validatedMenuItem.history">
                <ng-template mat-tab-label>
                    <a mat-list-item class="p15" (click)="naviagte(navlinks.history.url); toggler('history')">
                        <div class="usermenu">
                            <div>
                                <div class="menu-sub-text" [routerLink]="navlinks.history.url">
                                    {{navlinks.history.displayName}}</div>
                            </div>
                        </div>
                    </a>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <span style="width: 17%; float: right" class="project-heading">
            FVM
            <span class="project-sub-heading">(FREIGHT VERIFICATION MODULE)</span>
        </span>

        <img style="width: 2.5%;" src="../../../assets/images/logo-old@2x.png" class="toyota-logo" alt="Toyota Logo" />
    </nav>
</div>